import { Header } from '@tanstack/react-table';

type ColumnResizeHandlerProps = {
  header: Header<any, unknown>;
  onResizeStart: () => void;
};

export default function ColumnResizeHandler({
  header,
  onResizeStart,
}: ColumnResizeHandlerProps) {
  const resizeHandler = header.getResizeHandler();

  const handleMouseDown: React.MouseEventHandler<HTMLDivElement> = (event) => {
    onResizeStart();
    resizeHandler(event);
  };

  const handleTouchStart: React.TouchEventHandler<HTMLDivElement> = (event) => {
    onResizeStart();
    resizeHandler(event);
  };

  const handleDoubleClick: React.MouseEventHandler<HTMLDivElement> = (
    event,
  ) => {
    event.stopPropagation();

    const table = header.getContext().table;

    const size =
      (header.column.columnDef as any).size ??
      (header.column.columnDef as any).width ??
      75;

    table.setColumnSizing((prev) => ({
      ...prev,
      [header.column.id]: size,
    }));
  };

  return (
    <div
      className={`tan-table__resize-handle${
        header.column.getIsResizing() ? ' tan-table__resize-handle--active' : ''
      }`}
      onMouseDown={handleMouseDown}
      onTouchStart={handleTouchStart}
      onDoubleClick={handleDoubleClick}
      onClick={(e) => e.stopPropagation()}
    />
  );
}
